<template>
  <div
    class="layout-menu-container"
    v-if="this.$store.state.auth.status.loggedIn"
  >
    <AppSubmenu
      :items="model"
      class="layout-menu"
      :root="true"
      :forceOpen="forceOpen"
      @menuitem-click="onMenuItemClick"
    />
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";

export default {
  props: {
    model: Array,
    forceOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
  },
  components: {
    AppSubmenu: AppSubmenu,
  },
};
</script>

<style scoped></style>
